<script lang="ts">
    import lang from '../../lang/language';
    import type { ServiceType } from '../../store/types';
    import Map from '../../shared_components/Map.svelte';
    import ImageSlider from '../../shared_components/ImageSlider.svelte';
    import AddToWishlistButton from '../../shared_components/AddToWishlistButton.svelte';
    import { formatMoney, isDefinedNotNull } from '../../helpers/common';
    import { getLanguage, getUrlParam } from '../../helpers/url';
    import { currentLangIsJapanese } from '../../helpers/url';
    import SearchDetail from '../../shared_components/SearchDetail.svelte';
    import Card from '../services/Card.svelte';
    import Products from './Products.svelte';
    import { onMount } from 'svelte';

    export let selectedService: any;

    function getServiceType() {
        let serviceType = '';
        switch (selectedService.Type) {
            case 0:
                serviceType = lang.accommodation;
                break;
            case 1:
                serviceType = lang.activity;
                break;
            case 2:
                serviceType = lang.restaurant;
                break;
            case 3:
                serviceType = lang.produce;
                break;
            default:
                return lang.accommodation;
        }

        return serviceType;
    }
</script>

<section class="section-general">
    <div class="l-inner">
        <div class="planOverview">
            <h2 class="title-deco01">OVERVIEW</h2>
            <div class="planOverview__desc">
                <p>
                    {@html selectedService.LongDesc}
                </p>
            </div>
        </div>
    </div>
</section>
<section class="section-general dark">
    <div class="l-inner">
        <div class="search-detail bordered nara-season">
            <SearchDetail
                serviceType={selectedService.Type}
                onRequest={selectedService.OnRequestOnly}
            />
        </div>
        <Products onRequest={selectedService.OnRequestOnly} {selectedService} />
    </div>
</section>
<section class="section-general">
    <div class="l-inner">
        <p class="priceDetail__ttl">{lang.basic_info}</p>
        <div>
            <div class="row left-align table-row table-top">
                <div class="caption">{lang.name}</div>
                <div class="value">{selectedService.Name}</div>
            </div>
            {#if selectedService.Price}
                <div class="row left-align table-row">
                    <div class="caption">{lang.price}</div>
                    <div class="value">
                        {!currentLangIsJapanese() && selectedService.Price > 0
                            ? lang.from
                            : ''}
                        ¥{formatMoney(selectedService.Price)}
                        {currentLangIsJapanese() && selectedService.Price > 0
                            ? lang.from
                            : ''}
                    </div>
                </div>
            {/if}
            <div class="row left-align table-row">
                <div class="caption">{lang.address}</div>
                <div class="value">{selectedService.Address}</div>
            </div>
            <div class="row left-align table-row">
                <div class="caption">{lang.phone}</div>
                <div class="value">{selectedService.Phone || '-'}</div>
            </div>
            {#if selectedService.Fax}
                <div class="row left-align table-row">
                    <div class="caption">{lang.fax}</div>
                    <div class="value">{selectedService.Fax}</div>
                </div>
            {/if}
            <div class="row left-align table-row">
                <div class="caption">{lang.website}</div>
                <div class="value">
                    {#if selectedService.Website && isDefinedNotNull(selectedService.Website)}
                        <a href="http://{selectedService.Website}"
                            >{selectedService.Website}</a
                        >
                    {:else}
                        {lang.no_public_website}
                    {/if}
                </div>
            </div>
            <div class="row left-align table-row">
                <div class="caption">{lang.email}</div>
                <div class="value">
                    {#if isDefinedNotNull(selectedService.PublicEmail)}
                        <a href="mailto:{selectedService.PublicEmail}"
                            >{selectedService.PublicEmail}</a
                        >
                    {:else}
                        {lang.no_public_email}
                    {/if}
                </div>
            </div>
        </div>
    </div>
</section>
<section class="section-general dark">
    <div class="l-inner">
        <p class="priceDetail__ttl">{lang.map}</p>
        <div class="row">
            <Map
                zoomMap={10}
                services={[selectedService]}
                moveToCenter={true}
            />
        </div>
    </div>
</section>

<!-- <div class="details-wrapper">
    <div class="details-inner">
        <div class="row space-between">
            <div
                class="secondary-bg-color rounded bold bordered font nara-season"
                style="padding: 7px"
            >
                {getServiceType()}
            </div>
        </div>
        <div class="row left-align primary-font-color font nara-season">
            <h1>
                {selectedService.Name}
            </h1>
        </div>
        <div class="row center-align">
            <div style="width: 95%; max-width: 600px">
                <ImageSlider images={selectedService.Images} />
            </div>
        </div>
        <div class="long-desc left-align">
            {@html selectedService.LongDesc}
        </div>

        <div class="row">
            <div
                class="row left-align primary-font-color subtitle font bordered nara-season"
            >
                <h2 class="bg-before nara-season">{lang.basic_info}</h2>
            </div>
        </div>
        <div>
            <div class="row left-align table-row table-top">
                <div class="caption">{lang.name}</div>
                <div class="value">{selectedService.Name}</div>
            </div>
            {#if selectedService.Price}
                <div class="row left-align table-row">
                    <div class="caption">{lang.price}</div>
                    <div class="value">
                        {!currentLangIsJapanese() && selectedService.Price > 0
                            ? lang.from
                            : ''}
                        ¥{formatMoney(selectedService.Price)}
                        {currentLangIsJapanese() && selectedService.Price > 0
                            ? lang.from
                            : ''}
                    </div>
                </div>
            {/if}
            <div class="row left-align table-row">
                <div class="caption">{lang.address}</div>
                <div class="value">{selectedService.Address}</div>
            </div>
            <div class="row left-align table-row">
                <div class="caption">{lang.phone}</div>
                <div class="value">{selectedService.Phone || '-'}</div>
            </div>
            {#if selectedService.Fax}
                <div class="row left-align table-row">
                    <div class="caption">{lang.fax}</div>
                    <div class="value">{selectedService.Fax}</div>
                </div>
            {/if}
            <div class="row left-align table-row">
                <div class="caption">{lang.website}</div>
                <div class="value">
                    {#if selectedService.Website && isDefinedNotNull(selectedService.Website)}
                        <a href="http://{selectedService.Website}"
                            >{selectedService.Website}</a
                        >
                    {:else}
                        {lang.no_public_website}
                    {/if}
                </div>
            </div>
            <div class="row left-align table-row">
                <div class="caption">{lang.email}</div>
                <div class="value">
                    {#if isDefinedNotNull(selectedService.PublicEmail)}
                        <a href="mailto:{selectedService.PublicEmail}"
                            >{selectedService.PublicEmail}</a
                        >
                    {:else}
                        {lang.no_public_email}
                    {/if}
                </div>
            </div>
        </div>
        <div class="row">
            <div
                class="row left-align primary-font-color subtitle font bordered nara-season"
            >
                <h2 class="bg-before nara-season">{lang.map}</h2>
            </div>
        </div>
        <div class="row">
            <Map
                zoomMap={10}
                services={[selectedService]}
                moveToCenter={true}
            />
        </div>
    </div>
</div> -->
<style>
    .details-head {
        display: flex;
        justify-content: space-between;
        background: var(--primary-color);
        padding: 10px;
        color: white;
        align-items: center;
    }

    .head-title {
        width: 70%;
        height: 25px;
    }

    .details-inner {
        min-height: 200px;
        padding: 10px 60px;
        /*border: 1px solid var(--primary-color);*/
    }

    .search-detail {
        text-align: center;
        padding: 10px;
        border: 1px solid gray;
    }

    .subtitle {
        width: 100%;
        border-bottom: 3px solid var(--primary-color);
        padding: 10px 0px;
    }

    .subtitle > h2 {
        position: relative;
        padding-left: 20px;
    }

    .subtitle > h2:before {
        content: '';
        height: 100%;
        width: 10px;
        background: var(--primary-color);
        position: absolute;
        top: 0;
        left: 0;
    }

    .caption {
        width: 40%;
        max-width: 200px;
    }

    .value {
        width: 60%;
    }

    .table-row {
        border-bottom: 2px solid lightgrey;
        padding: 10px 0px;
        font-size: 1.5rem;
    }

    .table-top {
        border-top: 2px solid lightgray;
    }

    .long-desc {
        font-size: 14.4px;
        line-height: 1.7rem;
    }

    @media screen and (max-width: 1000px) {
        .details-inner {
            padding: 10px 20px;
        }
    }
</style>
